module.exports = __webpack_public_path__ + "static/FrankensteinPromo-15-de6ffa09b64f4e86b9df1db93694b7b2.jpg";